// CUSTOMIZATION:
// - added counter and changed styles

import React, { useState } from 'react';
import {
  Checkbox,
  Header,
  Accordion,
  AccordionContent,
  AccordionTitle,
} from 'semantic-ui-react';
import cx from 'classnames';
import {
  selectFacetSchemaEnhancer,
  selectFacetStateToValue,
  selectFacetValueToQuery,
} from '@plone/volto/components/manage/Blocks/Search/components/base';
import CaretSVG from '@redturtle/qubicaamf-theme/components/Icons/CaretSVG';

/**
 * A facet that uses radio/checkboxes to provide an explicit list of values for
 * filtering
 */
const CheckboxFacet = (props) => {
  const {
    facet,
    choices,
    isMulti,
    onChange,
    value,
    isEditMode,
    facetCounterData,
  } = props;
  const facetValue = value;

  const facetFieldName = facet.field.value;

  const [activeIndex, setActiveIndex] = useState(false);

  const handleClick = () => {
    setActiveIndex(!activeIndex);
  };

  return (
    <div className="checkbox-facet">
      <Accordion>
        <AccordionTitle active={activeIndex} onClick={handleClick}>
          <div className="h4">{facet.title ?? facet?.field?.label}</div>
          <div className="accordion-icon">
            <CaretSVG
              className={cx({
                'arrow-down': !activeIndex,
              })}
            />
          </div>
        </AccordionTitle>
        <AccordionContent active={activeIndex}>
          <div className="entries">
            {choices.map(({ label, value }, i) => {
              return facetCounterData[label] ? (
                <div className="entry" key={value}>
                  <Checkbox
                    id={value}
                    disabled={isEditMode}
                    label={label}
                    radio={!isMulti}
                    checked={
                      isMulti
                        ? !!facetValue?.find((f) => f.value === value)
                        : facetValue && facetValue.value === value
                    }
                    onChange={(e, { checked }) =>
                      onChange(
                        facet.field.value,
                        isMulti
                          ? [
                              ...facetValue
                                .filter((f) => f.value !== value)
                                .map((f) => f.value),
                              ...(checked ? [value] : []),
                            ]
                          : checked
                            ? value
                            : null,
                      )
                    }
                  />
                  {facet.show_counter && (
                    <div className="counter">{facetCounterData[label]}</div>
                  )}
                </div>
              ) : null;
            })}
          </div>
        </AccordionContent>
      </Accordion>
    </div>
  );
};

CheckboxFacet.schemaEnhancer = selectFacetSchemaEnhancer;
CheckboxFacet.stateToValue = selectFacetStateToValue;
CheckboxFacet.valueToQuery = selectFacetValueToQuery;

export default CheckboxFacet;
